import React, { useEffect } from 'react';
import './styles.css';
import { useLocation } from 'react-router';
import imgSuccess from '../../../src/img/success.gif';
import { Image } from '../../components/Image';
//import { GlobalContext } from '../../contexts/HomeContext';
import { ScrollToTop } from '../../utils/utils';
import { Link } from 'react-router-dom';

export const PageSuccess = () => {
  //const { dadosApp } = useContext(GlobalContext);
  const search = useLocation().search;
  const message = new URLSearchParams(search).get('msg');
  // const history = useHistory();
  // const [seconds, setSeconds] = useState(4);

  const TITLE = message.includes('Pagamento')
    ? 'Pagamento Realizado' // eslint-disable-next-line prettier/prettier
    : message.includes('Cadastro') ? 'Cadastro Realizado' : 'Pedido Enviado';

  useEffect(() => {
    ScrollToTop();
  }, []);

  // useEffect(() => {
  //   setInterval(() => {
  //     setSeconds((prevState) => prevState - 1);
  //   }, 1000);
  // }, [dadosApp.Url, history]);

  // useEffect(() => {
  //   if (seconds === 0) history.replace(dadosApp.Url + '&show=true');
  // }, [seconds, history, dadosApp]);

  return (
    <div style={{ backgroundColor: '#FFF' }}>
      <div style={{ backgroundColor: '#04AA6D', minHeight: '4.6875rem' }}>
        <h4 className="title-category" style={{ color: 'white', textAlign: 'center', padding: 17 }}>
          {TITLE}
        </h4>
      </div>
      <div id="top"></div>
      <div id="categorias"></div>
      <div
        className="container padTop20"
        style={{
          position: 'relative',
          height: '1000px',
          textAlign: 'center',
          margin: 'auto',
        }}
      >
        {!TITLE.includes('Cadastro') && (
          <p>Para realizar um novo pedido, ou conferir sua mesa, escaneie novamente o QRCode.</p>
        )}
        <Image srcLocal={imgSuccess} className="error-svg padTop20" alt="error" />
        <h1 style={{ marginTop: '30px' }}> {message}</h1>
        {TITLE.includes('Cadastro') && <Link to={`/loja/PreCadastro`}>Novo Cadastro</Link>}
      </div>
    </div>
  );
};
